import React from 'react'

import AlertDescriptionView from 'pages/AlertLookup/AlertDescriptionView'
import Modal from 'components/Modal'

import { AlertDescription } from 'types/Alert'

type Props = {
  isDisplayed: boolean;
  alertDescription: AlertDescription;
  closeCallback: () => void;
}

const AlertDescriptionModal = ({ isDisplayed, alertDescription, closeCallback }: Props) => {
  return (
    <Modal isDisplayed={isDisplayed} closeCallback={closeCallback}>
      {alertDescription && <AlertDescriptionView alertDescription={alertDescription} />}
    </Modal>
  )
}

export default AlertDescriptionModal
